import { ISortData }                   from '@shared/list-operations/components/sort-filter/sort-filter.model';
import {
	FilterType,
	IActiveFilters,
	IFilter
}                                      from '@shared/list-operations/model/filter.model';
import {
	IPaging,
	IPagingData
}                                      from '@shared/list-operations/model/paging.model';
import { ISearchData }                 from '@shared/list-operations/model/search.model';
import { ListOperationsHelperService } from '@shared/list-operations/services/list-operations-helper.service';

// ENUMS ##########################################################
export enum ListOperationsIdentifierEnum {
	ACCOUNTS_DETAIL_PAGE_SUBTENANTS_TAB_LIST = '[Accounts:DetailPage] Subtenants Tab List',
	ACCOUNTS_LIST_PAGE = '[Accounts:ListPage]',
	ADMIN_PAGE_FCC_TAB_FCC_VERSIONS_LIST = '[Admin:Page] Fcc Tab Fcc Versions List',
	ADMIN_PAGE_USER_TAB_LIST = '[Admin:Page] User Tab List',
	API_CLIENT_LIST_PAGE = '[ApiClients:ListPage]',
	BUSINESS_PREMISES_DETAIL_PAGE_ARCHIVE_EXPORTS = '[BusinessPremises:DetailPage] Archive Exports',
	BUSINESS_PREMISES_DETAIL_PAGE_ARCHIVE_EXPORT_ITEMS = '[BusinessPremises:DetailPage] Archive Export Items',
	BUSINESS_PREMISES_DETAIL_PAGE_ARCHIVE_IMPORTS = '[BusinessPremises:DetailPage] Archive Imports',
	BUSINESS_PREMISES_DETAIL_PAGE_ARCHIVE_IMPORTS_CASHPOINT_CLOSINGS = '[BusinessPremises:DetailPage | ArchiveImports:DetailPage ] Cashpoint Closings',
	BUSINESS_PREMISES_DETAIL_PAGE_ARCHIVE_OPEN_ARCHIVE = '[BusinessPremises:DetailPage] Open Archive',
	BUSINESS_PREMISES_DETAIL_PAGE_ARCHIVE_OPEN_ARCHIVE_BULK_KEYWORD_MODAL = '[BusinessPremises:DetailPage] Open Archive Bulk Keyword Modal',
	BUSINESS_PREMISES_DETAIL_PAGE_ARCHIVE_OPEN_ARCHIVE_EXPORT = '[BusinessPremises:DetailPage] Open Archive Export',
	BUSINESS_PREMISES_DETAIL_PAGE_ARCHIVE_PROCEDURAL_DOCUMENTATION = '[BusinessPremises:DetailPage] Procedural Documentation',
	BUSINESS_PREMISES_DETAIL_PAGE_ARCHIVE_PROCEDURAL_DOCUMENTS = '[BusinessPremises:DetailPage] Procedural Documents',
	BUSINESS_PREMISES_DETAIL_PAGE_ARCHIVE_PROCEDURAL_DOCUMENTATION_EXPORTS = '[BusinessPremises:DetailPage] Procedural Documentation Exports',
	BUSINESS_PREMISES_DETAIL_PAGE_ARCHIVE_TSS_LOGS = '[BusinessPremises:DetailPage] Tss Logs',
	BUSINESS_PREMISES_DETAIL_PAGE_ARCHIVE_TSS_LOGS_EXPORTS = '[BusinessPremises:DetailPage] Tss Logs Exports',
	BUSINESS_PREMISES_DETAIL_PAGE_FISKAL_ERSES = '[BusinessPremises:DetailPage] Fiskal Erses',
	BUSINESS_PREMISES_DETAIL_PAGE_FISKAL_ERSES_EXTERNAL = '[BusinessPremises:DetailPage] Fiskal Erses External',
	BUSINESS_PREMISES_DETAIL_PAGE_FISKAL_TSS_LOGS = '[BusinessPremises:DetailPage] Fiskal Tss Logs',
	BUSINESS_PREMISES_DETAIL_PAGE_FISKAL_OUTAGES = '[BusinessPremises:DetailPage] Fiskal Outages',
	BUSINESS_PREMISES_DETAIL_PAGE_TAXATION_REPORTINGS = '[BusinessPremises:DetailPage] Taxation Reportings',
	BUSINESS_PREMISES_LIST_PAGE = '[BusinessPremises:ListPage]',
	BUSINESS_PREMISES_LIST_PAGE_BULK_TAXATION_REPORTING = '[BusinessPremises:ListPage] Bulk Taxation Reporting',
	CONTRACTS_DETAIL_PAGE_TENANTS_TAB_LIST = '[Contracts:DetailPage] Tenants Tab List',
	CONTRACTS_LIST_PAGE_ARCHIVING_TAB = '[Contracts:ListPage] Archiving Tab',
	CONTRACTS_LIST_PAGE_ELSTER_TAB = '[Contracts:ListPage] Elster Tab',
	CONTRACTS_LIST_PAGE_FISKAL_TAB = '[Contracts:ListPage] Fiskal Tab',
	DASHBOARD_GLOBAL_STATISTICS = '[Dashboard:Global] Statistics View',
	ERS_LIST_PAGE = '[ERS:ListPage]',
	ERS_EXTERNAL_LIST_PAGE = '[ERS-EXTERNAL:ListPage]',
	MY_ACCOUNT_PAGE_ARCHIVING_TAB_CONTRACTS_TAB_LIST = '[MyAccount:Archiving Tab] Contracts Tab List',
	MY_ACCOUNT_PAGE_ELSTER_TAB_CONTRACTS_TAB_LIST = '[MyAccount:Elster Tab] Contracts Tab List',
	MY_ACCOUNT_PAGE_FISKAL_TAB_CONTRACTS_TAB_LIST = '[MyAccount:Fiskal Tab] Contracts Tab List',
	NOTIFICATIONS_LIST_PAGE = '[Notifications:ListPage]',
	ORGANIZATION_DETAIL_PAGE_BUSINESS_PREMISES_TAB_LIST = '[Organization:DetailPage] BusinessPremises Tab List',
	ORGANIZATION_DETAIL_PAGE_BULK_TAXATION_REPORTING = '[Organization:DetailPage] Bulk Taxation Reporting',
	ORGANIZATION_LIST_PAGE = '[Organization:ListPage]',
	STRUCTURE_EXPORT_LIST_PAGE = '[StructureExport:ListPage]',
	STRUCTURE_IMPORT_LIST_PAGE = '[StructureImport:ListPage]',
	TASK_CENTER_FCC_OPEN_TRANSACTIONS_LIST = '[TaskCenter:FccOpenTransactions] List View',
	TASK_CENTER_FCC_VERSIONS_LIST = '[TaskCenter:FccVersions] List View',
	TASK_CENTER_FISKAL_TSS_LOGS_LIST = '[TaskCenter:FiskalTssLogs] List View',
	TASK_CENTER_NOTIFICATIONS_LIST = '[TaskCenter:Notifications] List View',
	TASK_CENTER_OUTAGES_LIST = '[TaskCenter:Outages] List View',
	TASK_CENTER_OUTAGES_OVERVIEW = '[TaskCenter:Outages] Overview View',
	TAXATION_REPORTING_LIST_PAGE = '[TaxationReporting:ListPage]',
	TSS_LIST_PAGE = '[TSS:ListPage]',
	TSS_EXTERNAL_LIST_PAGE = '[TSS-EXTERNAL:ListPage]',
	USER_LIST_PAGE = '[User:ListPage]'
}

export enum ListOperationsEnum {
	SORT = 'sort',
	SEARCH = 'search',
	FILTER = 'filter',
	PAGINATION = 'pagination'
}

export enum ListOperationsRequestStateEnum {
	ABORTED = 'aborted',
	FINISHED = 'finished'
}

export enum ListOperationsResetEnum {
	ALL = 'all',
	FILTER = 'filter',
	FILTERS_ALL = 'filtersAll',
	PAGINATION = 'pagination',
	SEARCH = 'search',
	SORT = 'sort'
}

export enum ListOperationsResetModeEnum {
	CLEAR = 'clear',
	DEFAULT = 'default',
	RESTORE = 'restore'
}


// DECLARATIONS ###################################################
/**
 * Interface for component classes that uses ListOperators
 *
 * @listOperationsHelperService
 * listOperationsHelperService:
 * provides methods and members to initialize and interact with ListOperations.
 * Provide Service in Component Decorator and inject the helper service in constructor:
 * @example
 * \@Component( {
 *	selector: 'app-entity-list-page',
 *	templateUrl: './entity-list-page.component.html',
 *	styleUrls: [ './entity-list-page.component.scss' ],
 *	providers: [ ListOperationsHelperService ]
 * } )
 * export class EntityListPageComponent extends StickyBaseComponent implements IListOperationable {
 *
 * 	constructor(
 * 		public readonly listOperationsHelperService: ListOperationsHelperService
 * 	){}
 * 	}
 *
 *
 * @onListOperationChange
 * onListOperationChange:
 * Method to handle a ListOperationChange.
 * Call the same eventHandler method from the helper service, before performing data request call with listOperation params:
 * @example
 *	onListOperationChange( listOperations: ListOperations ): void {
 *		// optionally alter listOperations before calling onListOperationChange from ListOperationsHelperService
 *		listOperations = {
 * 			...listOperations,
 *			paging: { ...listOperations, pageSize: 50 }
 *		}
 *
 *		// call onListOperationChange from ListOperationsHelperService
 *		this.listOperationsHelperService.onListOperationChange( listOperations, 'caller identification string' );
 *
 *		// call data request
 *		this.loadList();
 *	}
 */
export declare interface IListOperationable {
	readonly listOperationsHelperService: ListOperationsHelperService;

	onListOperationChange( listOperationsData: ListOperations ): void;
}


// INTERFACES #####################################################
export interface IListOperationsConfig {
	id?: ListOperationsIdentifierEnum;

	listOperationsConfigDataMap?: {
		callback: ( listOperationsConfigData: IListOperationsConfig ) => IListOperationsConfig;
		operators: IOperators
	};

	pagingData?: IPagingData;	// TODO: remove when list ops re-working is finished

	searchData?: ISearchData;	// TODO: remove when list ops re-working is finished

	sortData?: ISortData[];		// TODO: remove when list ops re-working is finished

	filterData?: IFilter[];		// TODO: remove when list ops re-working is finished

	restoreListOperationsData?: IRestoreListOperationsData;

	reinitializeAndEmitListOperations?: boolean;
	instantFilteringIsEnabled?: boolean;

	activeData?: IOperators;

	defaultData?: IOperators;

	restoreData?: IOperators;
}

export interface IOperators {
	pagingData?: IPagingData;

	searchData?: ISearchData;

	sortData?: ISortData[];

	filterData?: FilterType[];
}

export interface IListOperationsHttpParams {

	activeFilters?: IActiveFilters;

	paging?: IPaging;

	search?: string[];

	sort?: string;
}

export interface ICollectedOperatorsData {
	searchHasChanged: boolean;
	sortHasChanged: boolean;
	filterHasChanged: boolean;
	search: string[];
	sort: string;
	activeFilters: IActiveFilters;
}

export interface IRestoreListOperationsData {
	operatorsData: {
		sort?: string;

		search?: string[];

		activeFilters?: IActiveFilters;

		paging?: {
			pageNumber: number;
		};
	};

	shouldRestoreData: boolean;
}

interface IListOperationsBaseReset {
	listOperator: ListOperationsResetEnum;
	resetMode: ListOperationsResetModeEnum;
	blockEmit?: boolean;
}

export interface IListOperationsAllReset extends IListOperationsBaseReset {
	listOperator: ListOperationsResetEnum.ALL;
}

export interface IListOperationsFilterItemReset extends IListOperationsBaseReset {
	listOperator: ListOperationsResetEnum.FILTER;
	identifier: number;
}

export interface IListOperationsFiltersReset extends IListOperationsBaseReset {
	listOperator: ListOperationsResetEnum.FILTERS_ALL;
}

export interface IListOperationsSearchReset extends IListOperationsBaseReset {
	listOperator: ListOperationsResetEnum.SEARCH;
}

export interface IListOperationsSortReset extends IListOperationsBaseReset {
	listOperator: ListOperationsResetEnum.SORT;
}

export interface IListOperationsPagingReset extends IListOperationsBaseReset {
	listOperator: ListOperationsResetEnum.PAGINATION;
}

export interface IResetEvent {
	service: string;
	resetMode: ListOperationsResetModeEnum;
	blockEmit?: boolean;
}

// TYPES ##########################################################

export type ListOperationsResetType =
	IListOperationsAllReset
	| IListOperationsFilterItemReset
	| IListOperationsFiltersReset
	| IListOperationsPagingReset
	| IListOperationsSearchReset
	| IListOperationsSortReset;

export type ResetListOperatorValueType = string[] | string | IActiveFilters;

// CLASSES ########################################################
export class ListOperations {

	public activeFilters?: IActiveFilters = undefined;

	public configData?: IListOperationsConfig = undefined;

	public filterIsInitialized?: boolean = undefined;

	public hideFilter?: boolean = undefined;

	public hideSearch?: boolean = undefined;

	public hideSort?: boolean = undefined;

	public id: ListOperationsIdentifierEnum = undefined;

	public paging?: IPaging = undefined;

	public pagingIsInitialized?: boolean = undefined;

	public renderFilter?: boolean = undefined;

	public renderSearch?: boolean = undefined;

	public renderSort?: boolean = undefined;

	public resetData?: ListOperationsResetType = undefined;

	public restoreListOperationsData?: IRestoreListOperationsData = undefined;

	public search?: string[] = undefined;

	public searchIsInitialized?: boolean = undefined;

	public sort?: string = undefined;

	public sortIsInitialized?: boolean = undefined;
}


// CONSTANTS ######################################################

export const listOperationsDefaults = {
	hideFilter: false,
	hidePagination: false,
	hideSearch: false,
	hideSort: false,
	renderFilter: true,
	renderPagination: true,
	renderSearch: true,
	renderSort: true
};
